module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "9.e54cfb36.jpg";